// Growlab 811 kinetic model — device + crop metadata (positions match the build directive).
export const DEVICES = [
  {
    id: "t8", name: "CLOUDLINE T8", tag: '8" INLINE EXHAUST', port: "UIS PORT 1",
    pos: [-3.8, 3.6, -3.8], color: "#f97316", img: "/assets/growlab/t8.png", uhd: "/assets/growlab/uhd/t8.jpg",
    role: "High-CFM PWM exhaust. Pulls hot, humid canopy air up and out the top rear port — the 88% RH mold-ceiling purge lives here.",
    metrics: [["TRIGGER", "86°F / 88% RH"], ["SPEED", "2–8 AUTO"], ["DUCT", '8" TOP REAR']],
  },
  {
    id: "raxial", name: "RAXIAL S6", tag: '6" BOOSTER INTAKE', port: "OUTLET AI+ · PORT 4",
    pos: [3.8, -3.5, 3.8], color: "#06b6d4", img: "/assets/growlab/raxial.png", uhd: "/assets/growlab/uhd/raxial.jpg",
    role: "Booster fan pulling fresh CO₂-rich air in low across the soil bed — the head of the diagonal air sweep. Not UIS-native, so the OUTLET AI+ gates its power.",
    metrics: [["TRIGGER", "84°F + PULSE"], ["PULSE", "10 MIN / 2 H"], ["DUCT", '6" FRONT LOW']],
  },
  {
    id: "cloudray", name: "CLOUDRAY S6", tag: "OSCILLATING CLIP FAN", port: "UIS PORT 2",
    pos: [4.2, 1.5, 0], color: "#e5c158", img: "/assets/growlab/cloudray.png", uhd: "/assets/growlab/uhd/cloudray.jpg",
    role: "Oscillating canopy breeze sweeping a 90° arc through the foliage — kills dead zones, strengthens tropical trunks. Speed 3 day / 2 night, continuous.",
    metrics: [["SWEEP", "90° ARC"], ["SPEED", "3 DAY / 2 NIGHT"], ["MODE", "CONTINUOUS"]],
  },
  {
    id: "cloudforge", name: "CLOUDFORGE T7", tag: "SMART HUMIDIFIER", port: "UIS PORT 3 · WIRELESS",
    pos: [-3.5, -3.5, -1.0], color: "#7dd3fc", img: "/assets/growlab/cloudforge.png", uhd: "/assets/growlab/uhd/cloudforge.jpg",
    role: "Ultrasonic misting unit feeding a vapor plume up behind the canopy — holds 70–85% RH for the cacao and banana. Linked over the UIS wireless 1-to-1 kit.",
    metrics: [["ON BELOW", "70% / 75% NIGHT"], ["CUTOFF", "80% / 85%"], ["VAPOR", "LEVEL 5–6"]],
  },
  {
    id: "controller", name: "CONTROLLER 69 PRO", tag: "UIS CENTRAL BRAIN", port: "CENTRAL HOST",
    pos: [5.8, 1.0, 4.2], color: "#e5c158", img: "/assets/growlab/controller.png", uhd: "/assets/growlab/uhd/controller.jpg",
    role: "Reads temp / RH / VPD at canopy height and drives all four UIS ports — every trigger, ramp and day-night schedule on the program card runs here. Mounted outside, dry side.",
    metrics: [["VPD", "1.05 kPa"], ["TEMP", "82.4°F"], ["RH", "76%"]],
  },
  {
    id: "outlet", name: "OUTLET AI+", tag: "SMART ENERGY PLUG", port: "PORT 4 · AUX",
    pos: [5.8, -3.4, 4.2], color: "#10b981", img: "/assets/growlab/outlet.png", uhd: "/assets/growlab/uhd/outlet.jpg",
    role: "UIS smart plug that gives the controller on/off authority over the non-UIS Raxial booster — intake automation without replacing the fan.",
    metrics: [["LOAD", "RAXIAL S6"], ["DRAW", "~35 W"], ["MODE", "AUTO FOLLOW"]],
  },
  {
    id: "mh1000", name: "MH 1000W 6000K", tag: "METAL HALIDE VEG LIGHT", port: "TIMER / LIGHT RAIL",
    pos: [1.6, 3.7, -0.4], color: "#bae6fd", img: "/assets/growlab/mh1000.png", uhd: "/assets/growlab/uhd/mh1000.jpg",
    role: "1000W E39 metal halide at 6000K — blue-weighted veg spectrum driving dense canopy structure on the mango/avocado side. Big heat source: the T8's 86°F trigger is sized around it.",
    metrics: [["POWER", "1000 W"], ["SPECTRUM", "6000K VEG"], ["HANG", "24–30 in"]],
  },
  {
    id: "cmh315", name: "CMH 315W 4200K", tag: "CERAMIC MH FULL SPECTRUM", port: "TIMER / LIGHT RAIL",
    pos: [-1.8, 3.7, 1.2], color: "#fcd34d", img: "/assets/growlab/cmh315.png", uhd: "/assets/growlab/uhd/cmh315.jpg",
    role: "315W ceramic metal halide, full-spectrum 4200K (590 µmol) as the daily driver over cacao/tamarind — swap to the 3000K bulb (625 µmol) when you want flower and fruit swell.",
    metrics: [["POWER", "315 W"], ["OUTPUT", "590–625 µmol"], ["HANG", "18–24 in"]],
  },
];

export const TREES = [
  { name: "Banana", img: "/assets/growlab/tree-banana.png", sci: "Musa", pos: [-2.5, 0, -2.0], h: 6.0, leaf: "#16a34a", canopy: 1.7 },
  { name: "Cacao", img: "/assets/growlab/tree-cacao.png", sci: "Theobroma", pos: [-2.0, 0, 1.7], h: 3.4, leaf: "#15803d", canopy: 1.3 },
  { name: "Tamarind", img: "/assets/growlab/tree-tamarind.png", sci: "Tamarindus", pos: [0.2, 0, 0.2], h: 4.4, leaf: "#65a30d", canopy: 1.5 },
  { name: "Mango", img: "/assets/growlab/tree-mango.png", sci: "Mangifera", pos: [2.3, 0, 1.8], h: 5.2, leaf: "#166534", canopy: 1.6 },
  { name: "Avocado", img: "/assets/growlab/tree-avocado.png", sci: "Persea", pos: [2.6, 0, -1.8], h: 4.8, leaf: "#14532d", canopy: 1.5 },
];

export const SOIL_BASE = -3.2; // top of the mulch layer — tree roots start here
